export const DMARC_NONE = 'none';
export const DMARC_QUARANTINE = 'quarantine';
export const DMARC_REJECT = 'reject';

export const DMARC_STATUS_INVALID = 'invalid';
export const DMARC_STATUS_NO_RECORD = 'no_record';

export const DMARC_STATUS_POLICY_INVALID = 'invalid_record';
export const DMARC_STATUS_POLICY_NONE = 'p_none';
export const DMARC_STATUS_POLICY_QUARANTINE = 'p_quarantine';
export const DMARC_STATUS_POLICY_REJECT = 'p_reject';

export const DMARC_POLICY_INHERITED_NONE = 'none';
export const DMARC_POLICY_INHERITED_EXPLICIT = 'explicit';
export const DMARC_POLICY_INHERITED_INHERITED = 'inherited';
export const DMARC_POLICY_INHERITED_SP = 'sp';
